export default {
  computed: {
    isJobDataIncorrect() {
      if (this.isEmploymentWorkFieldsDisabled) {
        return !this.work_info.employment_type;
      }

      return this.userData.role === 'borrower' ? (!this.work_info.employment_type || !this.work_info.scope_of_employment_type ||
        !this.work_info.organization_name || !this.work_info.job_position_type || !this.work_info.workExperience || (this.isOtherJobPositionType ? !this.work_info.job_position_name : false)) :
        (!this.work_info.employment_type || !this.work_info.scope_of_employment_type ||
          !this.work_info.organization_name || !this.work_info.job_position_type || (this.isOtherJobPositionType ? !this.work_info.job_position_name : false));
    }
  }
};